import React from "react"
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js"
import { Pie } from "react-chartjs-2"
import PropTypes from "prop-types"
import ChartDataLabels from "chartjs-plugin-datalabels"
import { solve_colors } from "./solve-status-colors"

ChartJS.register(ChartDataLabels, ArcElement, Tooltip, Legend)

/**
 * Component to render the solver status breakdown for observations over a period as a pie chart
 * @param solveCounts
 * @returns {JSX.Element}
 * @constructor
 */
const SolveStatusPie = ({ solveCounts = {} }) => {
  // Get the standardised set of colors
  let colors = []
  Object.entries(solveCounts).forEach(([key]) => {
    colors.push(solve_colors[key] || [54, 162, 235])
  })

  const dataset = {
    data: {
      labels: Object.keys(solveCounts),
      datasets: [
        {
          label: "count",
          data: Object.values(solveCounts),
          backgroundColor: colors.map(
            (c) => `rgba(${c[0]},${c[1]}, ${c[2]}, 0.2)`
          ),
          borderColor: colors.map((c) => `rgba(${c[0]},${c[1]}, ${c[2]}, 1)`),
          borderWidth: 1,
        },
      ],
    },
    options: {
      plugins: {
        title: {
          display: true,
          text: "Solve status",
        },
      },
    },
  }

  return <Pie data={dataset.data} options={dataset.options} />
}

SolveStatusPie.propTypes = {
  solveCounts: PropTypes.object,
}

export default SolveStatusPie
